import { render, staticRenderFns } from "./SamplePage.vue?vue&type=template&id=36dbae95"
import script from "./SamplePage.vue?vue&type=script&lang=js"
export * from "./SamplePage.vue?vue&type=script&lang=js"
import style0 from "./SamplePage.vue?vue&type=style&index=0&id=36dbae95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports